import { AllocationSocketManagerProps } from '../../types';
import { useAllocationCreateWSManager } from './allocation-create';
import { useAllocationDeleteWSManager } from './allocation-delete';
import { useAllocationUpdateWSManager } from './allocation-update';

export const useAllocationWSManager = (
  props: AllocationSocketManagerProps,
): void => {
  useAllocationCreateWSManager(props);
  useAllocationUpdateWSManager(props);
  useAllocationDeleteWSManager(props);
  // useAllocationShiftWSManager(props);
};
